/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:da4eeebd-7441-42ea-af4f-3953794521ac",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_n8tMtMPEC",
    "aws_user_pools_web_client_id": "3i9eh913p3omv8om6e4bl5p376",
    "oauth": {}
};


export default awsmobile;
